import { boxPlanningKeys } from "@/modules/boxPlanning/gateway/boxPlanningKeys"
import { BoxSlotDetailsEntity } from "@/modules/boxSlot/entities/boxSlotEntity"
import type { BoxSlotCreateOrUpdateInputDto } from "@/modules/boxSlot/gateway/boxSlotDto"
import { boxSlotKeys } from "@/modules/boxSlot/gateway/boxSlotKeys"
import { boxSlotSessionKeys } from "@/modules/boxSlotSession/gateway/boxSlotSessionKey"
import { useServicesContext } from "@modules/core/services/services.context"
import { useMutation, useQueryClient } from "@tanstack/react-query"

export function useBoxSlotsCreate() {
  const { boxSlotApi } = useServicesContext()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (slotInput: BoxSlotCreateOrUpdateInputDto) => {
      await boxSlotApi.createSlot(slotInput)
    },
    onSuccess: async () => {
      await queryClient.refetchQueries({ queryKey: boxPlanningKeys.slots() })
    },
  })
}

export function useBoxSlotsUpdate() {
  const { boxSlotApi } = useServicesContext()
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ slotId, slotInput }: { slotId: string; slotInput: BoxSlotCreateOrUpdateInputDto }) => {
      const result = await boxSlotApi.updateSlot(slotId, slotInput)
      return BoxSlotDetailsEntity.fromDto(result)
    },
    onSuccess: async (data, { slotId }) => {
      await queryClient.refetchQueries({ queryKey: boxPlanningKeys.slots() })
      await queryClient.setQueryData(boxSlotKeys.slot(slotId), data)
      await queryClient.invalidateQueries({
        queryKey: boxSlotSessionKeys.all,
      })
    },
  })
}

export function useBoxSlotsDelete() {
  const { boxSlotApi } = useServicesContext()
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (id: string) => {
      await boxSlotApi.deleteSlot(id)
    },
    onSuccess: async () => {
      // Amélioration possible invalider uniquement les slots qui sont endDate et startDate comprise dans le slot supprimé
      await queryClient.refetchQueries({ queryKey: boxPlanningKeys.all })
    },
  })
}
